import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  GET_CONSTITUENT_OPTIONS,
  RECEIVE_CONSTITUENT_OPTIONS,
  RECEIVE_DATA_ENRICHMENT_REQUEST,
  RECEIVE_DATA_HEALTH_STATS,
  RECEIVE_FIND_EMAIL_STATS,
  RECEIVE_LAST_MODIFIED_DATE,
  UPDATE_DATA_HEALTH_AMOUNT,
} from "@/components/data/admin/ducks/Actions"

const defaultFindEmailsState = {
  findEmailsConstituent: {},
  findEmailsCountMissingEmails: 0,
  findEmailsCountTotal: 0,
  findEmailsPiplOptions: {},
}

const defaultState = {
  ...defaultFindEmailsState,
  findEmailsQuery: "",
  constituentsRemaining: null,
  findEmailStats: {},
  lastModifiedDate: "",
  latestEnrichmentRequest: null,
  dataHealthStats: {},
}

const getRangeDisplay = (start, end) => {
  if (!start) return ""

  if (!end) return ` (since ${start.slice(0, 4)})`

  return ` [${start.slice(0, 4)}-${end.slice(0, 4)}]`
}

const updateEducation = (ed) => {
  ed.display = ed.degree
  if (ed.schoolName) ed.display += ` from ${ed.schoolName}`
  ed.display += getRangeDisplay(ed.startDate, ed.endDate)

  return ed
}

const updateJob = (job) => {
  job.display = job.jobTitle
  if (job.companyName) job.display += ` at ${job.companyName}`

  job.display += getRangeDisplay(job.jobStartDate, job.jobEndDate)

  return job
}

const adminDataReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_DATA_ENRICHMENT_REQUEST:
      return {
        ...oldState,
        latestEnrichmentRequest: action.resp.latestRequest,
      }

    case RECEIVE_LAST_MODIFIED_DATE:
      return {
        ...oldState,
        lastModifiedDate: action.lastModifiedDate,
      }

    case RECEIVE_FIND_EMAIL_STATS:
      return {
        ...oldState,
        findEmailStats: action.stats,
      }

    // This is sorta dumb, but identify array by position sent down
    case RECEIVE_DATA_HEALTH_STATS:
      return {
        ...oldState,
        dataHealthStats: action.stats,
        [action.stats.stats[0].field]: action.stats.stats[0].startingValue,
        [action.stats.stats[1].field]: action.stats.stats[1].startingValue,
        [action.stats.stats[2].field]: action.stats.stats[2].startingValue,
        [action.stats.stats[3].field]: action.stats.stats[3].startingValue,
        [action.stats.stats[4].field]: action.stats.stats[4].startingValue,
      }

    case UPDATE_DATA_HEALTH_AMOUNT:
      return {
        ...oldState,
        [action.field]: action.amount,
      }

    case GET_CONSTITUENT_OPTIONS:
      return {
        ...oldState,
        findEmailsQuery: action.query,
      }

    case RECEIVE_CONSTITUENT_OPTIONS: {
      const {
        findEmailsConstituent,
        findEmailsPiplOptions,
        findEmailsCountMissingEmails,
        findEmailsCountTotal,
        findEmailsQuery,
      } = action.resp

      // Note query is not in default state, because it will change
      // default state is to help reset when nothing gets returned
      if (findEmailsCountTotal === 0) {
        return {
          ...oldState,
          ...defaultFindEmailsState,
        }
      }

      if (findEmailsPiplOptions) {
        for (const opt of findEmailsPiplOptions.data) {
          if (opt.education) {
            opt.education = opt.education.map(updateEducation)
          }

          if (opt.job) {
            opt.job = opt.job.map(updateJob)
          }
        }
      }

      if (findEmailsConstituent) {
        if (findEmailsConstituent.positions) {
          findEmailsConstituent.positions = findEmailsConstituent.positions.map(updateJob)
        }

        if (findEmailsConstituent.degrees) {
          findEmailsConstituent.degrees = findEmailsConstituent.degrees.map(updateEducation)
        }
      }

      return {
        ...oldState,
        findEmailsConstituent,
        findEmailsPiplOptions,
        findEmailsCountMissingEmails,
        findEmailsCountTotal,
        findEmailsQuery,
      }
    }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default adminDataReducer
